import { useState } from 'react'
import { Drawer } from 'antd'
import { useSelector } from 'react-redux'
import InfoPanel from './InfoPanel'
import { StatusImageThumb, StatusImageModal } from '../uptimehistory/TrafficMetrics/statusImage'

// Bottom sheet showing the selected unit's detail: the most-recent status-image snapshot
// (#289 keeps the key on the Vehicle as latest_status_image_s3_key) + the InfoPanel.
// open when a unit is selected; onClose clears the selection in index.jsx.
export const UnitDetailSheet = ({ item, dispatch, open, onClose }) => {
  const token = useSelector(s => s.app.auth.token)
  const [imgOpen, setImgOpen] = useState(false)
  const key = item && item.latest_status_image_s3_key
  return (
    <Drawer placement="bottom" height="80%" open={open} onClose={onClose}
      className="rz-detail-sheet" title={item ? (item.vehicle_name || item.serial_number) : ''}>
      {item && (
        <>
          {key && (
            <div className="rz-sheet-snapshot">
              <div className="rz-sheet-snapshot-label">Latest view</div>
              <StatusImageThumb s3Key={key} token={token} onClick={() => setImgOpen(true)} />
            </div>
          )}
          <InfoPanel dispatch={dispatch} item={item} />
          {imgOpen && key && <StatusImageModal s3Key={key} token={token} onClose={() => setImgOpen(false)} />}
        </>
      )}
    </Drawer>
  )
}
export default UnitDetailSheet
